function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEconomy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDFB5"
    },
    d: "M455.556,361.391c0,52.006-42.159,94.165-94.165,94.165H150.609 c-52.006,0-94.165-42.159-94.165-94.165V150.609c0-52.006,42.159-94.165,94.165-94.165h210.782 c52.006,0,94.165,42.159,94.165,94.165V361.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF1D8"
    },
    d: "M255.999,56.444h-105.39c-52.006,0-94.165,42.159-94.165,94.165v210.782 c0,52.005,42.159,94.165,94.165,94.165h105.39V56.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AB94B"
    },
    d: "M271.294,242.104V187.76c25.526,4.476,25.531,20.337,25.531,26.111h30.589 c0-31.9-20.682-52.481-56.12-56.962v-21.724h-30.589v21.724c-35.437,4.481-56.12,25.061-56.12,56.962s20.682,52.48,56.12,56.961 v54.344c-25.526-4.476-25.531-20.337-25.531-26.111h-30.589c0,31.9,20.682,52.481,56.12,56.962v21.724h30.589v-21.724 c35.437-4.481,56.12-25.061,56.12-56.962S306.731,246.585,271.294,242.104z M215.174,213.871c0-5.774,0.005-21.635,25.531-26.111 v52.221C215.179,235.506,215.174,219.646,215.174,213.871z M271.294,325.177v-52.222c25.526,4.476,25.531,20.337,25.531,26.111 S296.82,320.7,271.294,325.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9755"
    },
    d: "M361.391,41.149H150.609c-60.355,0-109.46,49.104-109.46,109.461v51.652l-19.521-19.521L0,204.37 l56.444,56.444l56.443-56.444l-21.629-21.629l-19.52,19.52v-51.652c0-43.489,35.381-78.872,78.871-78.872H361.39 c43.488,0,78.871,35.381,78.871,78.872v78.379h30.589v-78.379C470.85,90.253,421.746,41.149,361.391,41.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7224"
    },
    d: "M512,316.038l-56.444-56.443l-56.443,56.443l21.63,21.629l19.52-19.52v43.244 c0,43.488-35.381,78.871-78.871,78.871H150.609c-43.488,0-78.871-35.381-78.871-78.871V291.42H41.149v69.971 c0,60.356,49.104,109.46,109.46,109.46h210.782c60.355,0,109.46-49.103,109.46-109.46v-43.245l19.521,19.52L512,316.038z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomy);
export default __webpack_public_path__ + "static/media/economy.6e163c0eb093b9aac17ca65a63e6b8df.svg";
export { ForwardRef as ReactComponent };